import * as React from 'react';

import styles from './styles.module.scss';

export const Container: React.FC<Partial<
  React.HTMLProps<HTMLDivElement>
>> = props => <div className={styles.container} {...props} />;

export default Container;
